import React, { memo } from 'react'

import {
  Button, Icon, Refresh, BrushAI, AIGeneratedGradientFilled, classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, number, shape, string } from 'prop-types'

import { iconSize } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import DownloadButton from 'Pods/ThreeDStudio/Shared/DownloadButton/DownloadButton'

const applyIcon = <Icon svgComponent={AIGeneratedGradientFilled} size={iconSize} notSpaced />
const regenerateIcon = <Icon svgComponent={Refresh} size={iconSize} notSpaced />
const editIcon = <Icon svgComponent={BrushAI} size={iconSize} notSpaced />

// Apply / regenerate / edit / download for one generated image. Rendered both inline
// under the conversation result and inside the lightbox, so the two cannot drift.
function Actions({ result, isGenerating, className = '', onApply, onRegenerate, onEdit }) {
  const t = useTranslation()

  return (
    <div className={classnames('image-assistant-panel__actions', className)}>
      <Button
        type="secondary"
        size="small"
        variant="with-icon"
        customClass="image-assistant-panel__action image-assistant-panel__action--ai"
        icon={applyIcon}
        onClick={onApply}
      >
        <span className="image-assistant-panel__action-label cgt-body-base-semibold">
          {t('imageAssistantPanel.actions.useForThreeDGeneration')}
        </span>
      </Button>
      <Button
        type="secondary"
        size="small"
        variant="with-icon"
        customClass="image-assistant-panel__action"
        icon={regenerateIcon}
        disabled={isGenerating}
        onClick={onRegenerate}
      >
        {t('imageAssistantPanel.actions.regenerate')}
      </Button>
      <Button
        type="secondary"
        size="small"
        variant="with-icon"
        customClass="image-assistant-panel__action"
        icon={editIcon}
        onClick={onEdit}
      >
        {t('imageAssistantPanel.actions.editImage')}
      </Button>
      <DownloadButton result={result} />
    </div>
  )
}

Actions.propTypes = {
  result: shape({ id: number, url: string, alt: string }).isRequired,
  isGenerating: bool.isRequired,
  className: string,
  onApply: func.isRequired,
  onRegenerate: func.isRequired,
  onEdit: func.isRequired,
}

export default memo(Actions)
